export default "__VITE_ASSET__Dz97ImR$__"